module.exports = __webpack_public_path__ + "static/media/call_to_action.e6ce241b.svg";